import '.c{display:flex;}.ssr-plugin'
import '.d{justify-content:center;}.ssr-plugin'
import '.g{flex-direction:column;}.ssr-plugin'
import '.h{align-items:center;}.ssr-plugin'
import '.al{gap:0.5rem;}.ssr-plugin'
import '.ar{cursor:pointer;}.ssr-plugin'
import '.ex{padding:0.75rem;}.ssr-plugin'
import '.ae{border-radius:1.25rem;}.ssr-plugin'
import '.am{border:var(--border-subtle);}.ssr-plugin'
import '.af{background-color:var(--palette-white);}.ssr-plugin'
import '.cd{transition:background-color 0.2s ease;}.ssr-plugin'
import '.d0{width:2.5rem;}.ssr-plugin'
import '.d1{height:2.5rem;}.ssr-plugin'
import '.iv{color:var(--palette-blue-700);}.ssr-plugin'
import '.iw{font-size:0.9rem;}.ssr-plugin'
import '.a9{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="c d g h al ar ex ae am af cd"
        style={{
          '&:hover': {
            backgroundColor: 'var(--palette-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="d0 d1 c h d iv"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="iw iv a9"
        >
          {label}
        </span>
      </styled.button>
    )
}